export const ADMIN = 'agentAccount'

const notEmpty = (val) => {
    if (!val) return false
    return val !== ''
}
const encryptAdmin = (val) => {
    return window.btoa(val);
}
const decryptAdmin = (val) => {
    if (!val) return undefined;
    if (val.toString().charAt(0)===`"`){
        val = val.toString().slice(1, -1);
    }
    return JSON.parse(window.atob(val))
}

const getValue = (key) => {
    let value = localStorage.getItem(key);
    if (key === ADMIN){
        return decryptAdmin(value)
    }
    return JSON.parse(value);
}
const removeValue = (key) => {
    localStorage.removeItem(key);
}
const setValue = (key , value) => {
    value = JSON.stringify(value);
    if (key === ADMIN){
        value = encryptAdmin(value)
    }
    localStorage.setItem(key,value)
}

export const Storage = {
    setAdminUser: async (payload) => setValue(ADMIN,payload),
    getAdminUser: () => getValue(ADMIN),
    removeAdminUser: () => removeValue(ADMIN),
    getAgentName : () => {
        let details = getValue(ADMIN)
        if (!details) return null;
        return details.Name+` `+details.Surname;
    },

    getAgentID : () => {
        let details = getValue(ADMIN)
        if (!details) return null;
        return details.id;
    },
}
